import { makeStyles, Box, Typography } from '@material-ui/core';


const useStyles = makeStyles((theme) => ({
  emptyState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '90%',
    color: '#94a3b8',
    textAlign: 'center',
  },
  emptyIcon: {
    fontSize: 48,
    color: '#e2e8f0',
    marginBottom: theme.spacing(2),
  }
}));


const AIAssistanceEmptyState = () => {
    const classes = useStyles()
    return (
        <Box className={classes.emptyState}>
            <Box 
              mb={3} 
              p={2} 
              bgcolor="#f8fafc" 
              borderRadius={12} 
              border="1px dashed #cbd5e1"
              maxWidth={400}
            >
              <img src="/node_icons/ai.png" style={{width: '3rem'}} alt="hyperblox agent"/>
              <Typography variant="subtitle1" style={{ color: '#1e293b', fontWeight: 700, marginBottom: 8 }}>
                Build your blueprint with Hyperblox Agent
              </Typography>
              <Typography variant="body2" style={{ color: '#64748b', lineHeight: 1.6, textAlign: "center" }}>
                Describe the system you want to build. I’ll generate the System Model, Database Schema, Views, Transactions and Simulations for you.
              </Typography>
            </Box>
        </Box>
    )
}

export default AIAssistanceEmptyState;